import _defineProperty2 from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import { log } from '@jutro/logger';
import { HttpRequest } from './HttpRequest';
import { fastOptionsMerge } from './helper';
export let REQUEST_HANDLER_TYPE;
(function (REQUEST_HANDLER_TYPE) {
  REQUEST_HANDLER_TYPE["AUTH"] = "onAuth";
  REQUEST_HANDLER_TYPE["FETCH"] = "onFetch";
  REQUEST_HANDLER_TYPE["ENCODE"] = "onEncode";
  REQUEST_HANDLER_TYPE["ERROR"] = "onErrorResponse";
  REQUEST_HANDLER_TYPE["EXCEPTION"] = "onException";
  REQUEST_HANDLER_TYPE["RESPONSE"] = "onResponse";
  REQUEST_HANDLER_TYPE["TRACE"] = "onTrace";
})(REQUEST_HANDLER_TYPE || (REQUEST_HANDLER_TYPE = {}));
const REQUEST_HANDLER_TYPE_VALUES = _Object$values(REQUEST_HANDLER_TYPE);
export let HttpRequestBuilder = function HttpRequestBuilder(baseUrl = '') {
  _classCallCheck(this, HttpRequestBuilder);
  _defineProperty(this, "baseUrl", void 0);
  _defineProperty(this, "options", void 0);
  _defineProperty(this, "handlers", void 0);
  _defineProperty(this, "addOptions", options => {
    this.options.push(options);
    return this;
  });
  _defineProperty(this, "addHandler", (event, callback) => {
    if (typeof event === 'string') {
      if (_includesInstanceProperty(REQUEST_HANDLER_TYPE_VALUES).call(REQUEST_HANDLER_TYPE_VALUES, event) && callback) {
        this.handlers.push({
          [event]: callback
        });
      } else {
        log.warning(`Invalid event type "${event}" supplied to "HttpRequestBuilder.addHandler()"`);
      }
    } else if (_someInstanceProperty(REQUEST_HANDLER_TYPE_VALUES).call(REQUEST_HANDLER_TYPE_VALUES, t => event[t])) {
      this.handlers.push(event);
    } else {
      log.warning(`Invalid event type supplied to "HttpRequestBuilder.addHandler()"`);
    }
    return this;
  });
  _defineProperty(this, "build", () => {
    var _context, _context2;
    const options = this.options.length ? _reduceInstanceProperty(_context = this.options).call(_context, (list, values) => {
      return fastOptionsMerge(list, values);
    }) : undefined;
    const handlers = this.handlers.length ? _reduceInstanceProperty(_context2 = this.handlers).call(_context2, (list, values) => {
      return _objectSpread({}, list, {}, values);
    }) : undefined;
    return new HttpRequest(this.baseUrl, options, handlers);
  });
  this.baseUrl = baseUrl;
  this.handlers = [];
  this.options = [];
};